import React, { Component } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../style-sheets/products.css";
import { connect } from "react-redux";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import { APILINK } from "../../Endpoint";
import { Spin } from "antd";

const axiosApiInstance = axios.create();

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      tableData: [],
      keyWord: "",
      showMsg: false,
      columns: [
        {
          name: "Product name",
          selector: "name",
          sortable: true,
          right: true
        },
        {
          name: "Product code",
          selector: "code",
          sortable: true,
          right: true
        },
        {
          name: "Market Price",
          selector: "price",
          sortable: true,
          right: true
        },

        {
          name: "Yanzo Price",
          selector: "yanzo_price",
          sortable: true,
          right: true
        },

        {
          name: "Quantity",
          selector: "quantity",
          sortable: true,
          right: true
        },

        {
          name: "Actions",
          button: true,
          cell: (row) => (
            <div className="courierTable">
              <Link to={`/view_product/${row.id}`}>
                <i class="fas fa-eye"></i>{" "}
              </Link>
              <Link to={`/edit_product/${row.id}`}>
                {" "}
                <i class="fas fa-edit"></i>
              </Link>
              <i id={row.id} onClick={this.show} class="fas fa-trash"></i>{" "}
            </div>
          )
        }
      ],
      proId: "",

      nextUrl: "",
      prevUrl: "",
      dis1: true,
      dis2: false
    };
  }

  refreshAccessToken = () => {
    axios
      .post(APILINK + `/auth/jwt/refresh`, {
        refresh: localStorage.getItem("refreshToken")
      })
      .then(
        (response) => {
          return response;
        }

        // this.setState({ tableData: response.data })
      );
  };

  getAll = async () => {
    this.setState({ loading: true });
    var newID =
      this.props.user.user_type === "3"
        ? this.props.user.supplier_id.replace(/-/g, "")
        : this.props.user.id.replace(/-/g, "");

    const result = await axiosApiInstance.get(
      APILINK + `/products/?supplier=${newID}&limit=10`
    );
    if (result) {
      this.setState({ tableData: result.data.results, loading: false });

      if (result.data.next !== null) {
        this.setState({
          nextUrl: result.data.next
        });
      }

      if (result.data.previous !== null) {
        this.setState({
          prevUrl: result.data.previous
        });
      }
      if (result.data.next === null) {
        this.setState({ dis2: true });
      }
    }
  };

  componentDidMount() {
    this.getAll();
    let x = [
      {
        name: "",
        price: "",
        yanzo_price: "",
        code: "",
        quantity: ""
      }
    ];
    this.setState({ fileData: x });
  }

  onSearch = (e) => {
    console.log(e.target);
    this.setState({ keyWord: e.target.value });
    let x = this.state.tableData.filter(
      (item) =>
        item.name &&
        item.name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    console.log(x);
    this.setState({ tableData: x });
    if (e.target.value === "") {
      this.getAll();
    }
  };

  handleSelected = (state) => {
    console.log("Selected Rows: ", state.selectedRows);
    this.setState({ selectedRows: state.selectedRows });
  };

  show = (e) => {
    this.setState({ showMsg: true, proId: e.target.id });
    console.log(e.target.id);
  };
  hide = (e) => {
    this.setState({ showMsg: false });
  };

  deleteProduct = async (e) => {
    var newID = this.props.user.id.replace(/-/g, "");
    const res = await axiosApiInstance
      .delete(APILINK + `/product/${this.state.proId}`)
      .then((res) =>
        this.setState((state, props) => {
          return { showMsg: false };
        })
      )
      .catch((err) => console.log(err));
    console.log(res);
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevState.showMsg !== this.state.showMsg) {
      this.getAll();
    }
  }

  getNext = async () => {
    console.log(this.state.nextUrl);

    const result = await axiosApiInstance.get(`${this.state.nextUrl}`);

    console.log("orderssss");

    console.log(result.data);
    this.setState({
      tableData: result.data.results
    });
    if (result.data.next !== null) {
      this.setState({
        nextUrl: result.data.next
      });
    }
    if (result.data.previous !== null) {
      this.setState({
        prevUrl: result.data.previous,
        dis1: false
      });
    }
    if (result.data.next === null) {
      this.setState({ dis2: true, dis1: false });
    }
  };

  getPrev = async () => {
    const result = await axiosApiInstance.get(`${this.state.prevUrl}`);

    console.log("orderssss");
    console.log(result.data);
    this.setState({
      tableData: result.data.results
    });
    if (result.data.next !== null) {
      this.setState({
        nextUrl: result.data.next,
        dis2: false
      });
    }
    if (result.data.previous !== null) {
      this.setState({
        prevUrl: result.data.previous
      });
    }
    if (result.data.previous === null) {
      this.setState({ dis1: true, dis2: false });
    }
  };

  downLoadCatalog = (e) => {
    this.downloadCSV2(this.state.fileData);
  };

  convertArrayOfObjectsToCSV2 = (array) => {
    let result;

    const columnDelimiter = ",";
    const lineDelimiter = "\n";
    const keys = Object.keys(this.state.fileData[0]);

    result = "";
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    array.forEach((item) => {
      let ctr = 0;
      keys.forEach((key) => {
        if (ctr > 0) result += columnDelimiter;

        result += item[key];

        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  };

  downloadCSV2 = (array) => {
    const link = document.createElement("a");
    let csv = this.convertArrayOfObjectsToCSV2(array);
    if (csv == null) return;

    const filename = "export.csv";

    if (!csv.match(/^data:text\/csv/i)) {
      this.state.fileData = this.state.fileData;
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }

    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", filename);
    link.click();
  };

  onUpload = async (event) => {
    this.setState({ showSpinner: true });

    this.setState({ selectedFile: event.target.files[0] });

    const eventdata = new FormData();
    if (event.target.files[0]) {
      eventdata.append("file", event.target.files[0]);
    }

    const result = await axiosApiInstance.post(
      APILINK + `/product_upload_file`,
      eventdata
    );
    if (result.data.data === "done") {
      this.setState({ showSpinner: false, check: true });
      setTimeout(() => {
        this.setState({ showSpinner: false, check: false });
        this.getAll();
      }, 3000);
    }
  };
  render() {
    return (
      <div>
        <Container
          style={{ marginTop: "80px", marginLeft: "300px" }}
          className="py-3"
        >
          <Row>
            <Col className="p-4 mb-4" style={{ textAlign: "initial" }} sm={12}>
              <h2>
                {" "}
                <i
                  style={{ cursor: "pointer" }}
                  class="fas fa-chevron-left px-1"
                  onClick={this.props.history.goBack}
                ></i>{" "}
                <i class="fas fa-shopping-basket"></i> Products
              </h2>
            </Col>
          </Row>
          <Row className="my-2">
            <Col style={{ textAlign: "initial" }} sm={8}>
              <Button onClick={this.downLoadCatalog} className="headBtn">
                Download Product Catalog
              </Button>
              <input
                onChange={this.onUpload}
                type="file"
                className="customBtn3"
              />

              {this.state.showSpinner === true ? (
                <Spin tip="Loading..."></Spin>
              ) : null}
              {this.state.check === true ? (
                <i className="fas fa-check-circle checkk"></i>
              ) : null}
            </Col>
            <Col style={{ textAlign: "end" }} sm={4}>
              <Link to="/add_product">
                {" "}
                <Button className="headBtn">Add Product</Button>
              </Link>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              {this.state.loading === false ? (
                <DataTable
                  columns={this.state.columns}
                  data={this.state.tableData}
                  // selectableRows
                  onSelectedRowsChange={this.handleSelected}
                />
              ) : (
                <Col className="text-center" sm={12}>
                  {this.state.loading ? (
                    <Spin tip="Loading..."></Spin>
                  ) : (
                    "No data to be displayed"
                  )}
                </Col>
              )}
            </Col>
          </Row>
          <Row>
            <Col style={{ textAlign: "initial" }} sm={12}>
              {this.state.tableData.length === 0 ? null : (
                <div className="p-3">
                  {" "}
                  <Button
                    disabled={this.state.dis1}
                    onClick={this.getPrev}
                    className="nextBtn"
                  >
                    <i class="fas fa-angle-double-left"></i> Previous
                  </Button>
                  <Button
                    disabled={this.state.dis2}
                    onClick={this.getNext}
                    className="nextBtn"
                  >
                    Next<i class="fas fa-angle-double-right pl-1"></i>
                  </Button>
                </div>
              )}
            </Col>
          </Row>
        </Container>

        <Modal show={this.state.showMsg} onHide={this.hide}>
          <Container className="p-4">
            <Row>
              <Col className="text-center" sm={12}>
                {" "}
                <h6>Are u sure u want to delete this product?</h6>
              </Col>
              <Row style={{ margin: "auto" }}>
                <Col md={12}>
                  <Button onClick={this.deleteProduct} className="headBtn">
                    Delete
                  </Button>
                  <Button className="headBtn" onClick={this.hide}>
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Row>
          </Container>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuth: state.auth.isAuth,
  user: state.auth.user
});

export default connect(
  mapStateToProps,
  null
)(ErrorHandler(Products, axiosApiInstance));
